import { render, staticRenderFns } from "./advantagePosition.vue?vue&type=template&id=1b4fdecd&scoped=true"
import script from "./advantagePosition.vue?vue&type=script&lang=js"
export * from "./advantagePosition.vue?vue&type=script&lang=js"
import style0 from "./advantagePosition.vue?vue&type=style&index=0&id=1b4fdecd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4fdecd",
  null
  
)

export default component.exports